import React from "react";
import styled from "@emotion/styled";
import get from "lodash.get";
import { injectIntl } from "react-intl";

import { Doughnut } from "react-chartjs-2";
import { Paper } from "@mui/material";

import ParkkiTheme from "themes/ParkkiTheme";
import VisitorCharacteristicsUtils from "services/visitorCharacteristics/utils";

import Placeholder from "components/Placeholder";
import GraphLegend from "components/GraphLegend";
import Section from "components/Section";
import ToggleButtonGroup from "components/ToggleButtonGroup";

const ToggleButtonGroupContainer = styled.div`
  display: flex;
  flex: 1;
  margin-bottom: 10px;
`;
const GraphSection = styled(Paper)`
  position: relative;
  display: flex;
  flex-direction: row;
  padding: ${ParkkiTheme.spacings.base};
`;

const GraphsContainer = styled.div`
  display: flex;
  flex: 1;
  justif-content: center;
  align-items: center;
  flex-direction: column;
  width: 200px;
  height: 100%;
`;

function QualitificationVisitorsSectionComponent({
  intl,
  visitorCharacteristics,
  setQualificationVisitorsFilters,
}) {
  const qualificationVisitorsCharts =
    VisitorCharacteristicsUtils.getQualificationVisitorsChart(
      get(visitorCharacteristics, "qualificationVisitors"),
      intl
    );

  const options = new Array(7).fill(0).map((item, index) => ({
    label: intl.messages[`daysOfWeek.${index}`],
    value: index + 1,
  }));
  const selectedDays =
    get(visitorCharacteristics, "qualificationVisitors.filters.dow") &&
    Array.isArray(
      get(visitorCharacteristics, "qualificationVisitors.filters.dow")
    )
      ? get(visitorCharacteristics, "qualificationVisitors.filters.dow")
      : [get(visitorCharacteristics, "qualificationVisitors.filters.dow")];

  return (
    qualificationVisitorsCharts && (
      <Section
        title={
          intl.messages[
            "visitorCharacteristicsScene.sections.qualificationVisitors.title"
          ]
        }
      >
        <ToggleButtonGroupContainer>
          <ToggleButtonGroup
            loading={!visitorCharacteristics.qualificationVisitors.initialized}
            options={options}
            value={selectedDays || []}
            onChange={(e, value) => {
              if (
                value === null ||
                (Array.isArray(value) && value.length === 0)
              ) {
                return null;
              }
              return setQualificationVisitorsFilters({ dow: value });
            }}
          />
        </ToggleButtonGroupContainer>

        {!visitorCharacteristics?.qualificationVisitors?.initialized ? (
          <Placeholder height="180px" />
        ) : null}

        {visitorCharacteristics?.qualificationVisitors?.initialized ? (
          <GraphSection>
            <GraphsContainer>
              <Doughnut
                data={qualificationVisitorsCharts?.visitors?.data}
                options={qualificationVisitorsCharts?.visitors?.options}
                onElementsClick={() => {}}
              />
              <GraphLegend
                data={qualificationVisitorsCharts?.visitors?.legend}
                type="column"
              />
            </GraphsContainer>
            <GraphsContainer>
              <Doughnut
                data={qualificationVisitorsCharts?.categorizedVisitors?.data}
                options={
                  qualificationVisitorsCharts?.categorizedVisitors?.options
                }
                onElementsClick={() => {}}
              />
              <GraphLegend
                data={qualificationVisitorsCharts?.categorizedVisitors?.legend}
                type="column"
              />
            </GraphsContainer>
          </GraphSection>
        ) : null}
      </Section>
    )
  );
}

export default injectIntl(QualitificationVisitorsSectionComponent);
